import { useNavigate } from 'react-router-dom';

import { Layout } from '@components/Layout';
import { paths } from '@constants/paths';
import { DepositDetails } from '@features/Deposit';
import { useIsIframeOn } from '@features/Deposit/useIsIframeOn';
import { withProfiler } from '@services/sentry/withProfiler';

const DepositPageUnwrapped = () => {
  const navigate = useNavigate();

  const refreshPage = () => {
    window.location.replace(window.location.pathname);
  };

  const goBack = () => {
    navigate(paths.confirm);
  };

  return (
    <Layout
      title="Deposit payment"
      onBack={useIsIframeOn() ? refreshPage : goBack}
    >
      <DepositDetails />
    </Layout>
  );
};

const DepositPage = withProfiler(DepositPageUnwrapped);

export { DepositPage };
